"use client";

import React from "react";
import Link from "next/link";

const OurCommunity: React.FC = () => {
  return (
    <>
      <section className="relative w-full bg-gradient-to-br from-gray-50 to-white pt-32 pb-12 sm:pt-36 sm:pb-16 overflow-hidden">
        {/* Decorative background elements */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-br from-[#ECD05B]/10 to-transparent rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-tr from-[#AE7D2F]/10 to-transparent rounded-full blur-3xl" />

        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-8 lg:px-12">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-gray-900 text-center after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:my-5 after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)] mb-12">
            Serving Our Queens NY Community
          </h1>

          <div className="space-y-8 text-base sm:text-lg text-gray-700 leading-relaxed">
            <div>
              <h3 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4">
                Smile4Me: Serving the Astoria, Queens Community
              </h3>
              <p>
                Astoria is more than just our location—it&#39;s our home.
                We&#39;re proud to be part of this lively Queens neighborhood,
                known for its rich culture, diverse dining, and scenic beauty.
                When you visit Smile4Me, you&#39;re not just a
                patient—you&#39;re part of our Astoria family.
              </p>
              <p>
                Explore Astoria while enjoying the benefits of Smile4Me&#39;s
                exceptional care. Whether you&#39;re strolling through{" "}
                <strong>Astoria Park</strong>, visiting the{" "}
                <strong>Museum of the Moving Image</strong>, or savoring a meal
                at a local restaurant, a healthy smile can make your experiences
                even brighter.
              </p>
            </div>

            <div>
              <h3 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4">
                Our Commitment to Quality and Comfort
              </h3>
              <p>
                At Smile4Me, we know that visiting the dentist can be stressful
                for some, which is why we prioritize comfort and care at every
                step. Our <strong>friendly team</strong> and advanced dental
                technology make it possible to receive high-quality care with
                minimal discomfort.
              </p>
            </div>

            <div>
              <h3 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4">
                Schedule Your Appointment with Smile4Me Today
              </h3>
              <p>
                Ready to experience top-notch dental care in Astoria, Queens?
                Whether you&#39;re in need of routine maintenance, cosmetic
                enhancements, or{" "}
                <Link
                  href="/services/emergency-treatment"
                  className="text-[#d5ac26] hover:underline font-semibold"
                >
                  emergency dental care
                </Link>
                , Smile4Me is here to help.
              </p>
            </div>
          </div>

          <div className="mt-12 text-center">
            <Link
              href="/contact"
              className="uppercase font-bold text-lg tracking-wide text-white px-6 py-3 bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] hover:from-[#ECD05B] hover:via-[#AE7D2F] hover:to-[#ECD05B] rounded-lg shadow-lg hover:shadow-inner [text-shadow:1px_1px_2px_rgba(0,0,0,0.5)] hover:scale-105 transition-all duration-300 ease-in-out"
              onClick={() => console.log("Schedule Appointment button clicked")}
            >
              Schedule Your Appointment
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default OurCommunity;